export default __webpack_public_path__ + "static/media/IMG_0414.7805d6be.jpg";